import { Card } from '@/components/ui'; // Assurez-vous du bon import
import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';

const UserCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <Card
      className={cn(
        
        'w-full relative overflow-hidden border-border shadow-xs pointer-events-none select-none',
        className
      )}
    >
     
      <div className="relative w-full aspect-square bg-muted/10">
        <Skeleton className="w-full h-full rounded-none" />
      </div>

      <div className="bg-card border-t border-border p-3">
        <div className="flex flex-col space-y-3">
          
         
          <Skeleton className="h-4 w-3/4 rounded-sm" />
          
          
          <Skeleton className="h-3 w-1/2 rounded-sm opacity-70" />

         
          <div className="pt-2 flex gap-2">
            <Skeleton className="h-8 flex-1 rounded-md" /> 
            <Skeleton className="h-8 w-8 rounded-md" />   
          </div>
        </div>
      </div>
    </Card>
  );
};

export default UserCardSkeleton;